import { useRouteDashboard } from "../../hooks";
import { useParams } from "react-router-dom";
import { PageHeader } from "@shared/components/PageHeader";

export const KeyStats = () => {
  const { route_id } = useParams();
  const { data } = useRouteDashboard(route_id);
  const stats = [
    { label: "Total Premises", value: data?.result?.totalPremises || 0 },
    {
      label: "Total Meters",
      value: data?.result?.premiseMeters?.total || 0,
    },
    {
      label: "Assigned Meters",
      value: data?.result?.premiseMeters?.active || 0,
    },
    {
      label: "Unassigned Meters",
      value: data?.result?.premiseMeters?.inactive || 0,
    },
  ];

  return (
    <div className="rounded-xl border border-gray-200 p-5 mb-2">
      <PageHeader
        title="Key Stats"
        subtitle="Snapshot of route metrics for quick assessment"
      />

      <div className="space-y-2 mt-3">
        {stats.map((item) => (
          <div key={item.label} className="flex justify-between text-sm mt-2">
            <span className="text-gray-700">{item.label}</span>
            <span className="font-semibold text-gray-900">{item.value}</span>
          </div>
        ))}
      </div>
    </div>
  );
};
